"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const window_or_global_1 = __importDefault(require("window-or-global"));
function startTalon({ flow, onSuccess, onFailed, onCancel }) {
    if (!window_or_global_1.default.talon) {
        handleSuccess(); // in case user can't load talon script
        return;
    }
    function handleExecute() {
        window_or_global_1.default.talon.execute(flow);
    }
    function handleSuccess(...args) {
        onSuccess(...args);
    }
    function handleCancel(...args) {
        onCancel(...args);
    }
    function handleError(...args) {
        console.error('talon error');
        onFailed(...args);
    }
    function runTalon() {
        if (!window_or_global_1.default.talon.flows[flow]) {
            loadTalon();
        }
        const currentFlow = window_or_global_1.default.talon.flows[flow];
        currentFlow.config.onComplete = handleSuccess;
        currentFlow.config.onClosed = handleCancel;
        currentFlow.config.onFailed = handleError;
        if (currentFlow.ready) {
            handleExecute();
        }
        else {
            currentFlow.config.onReady = function () {
                handleExecute();
            };
        }
    }
    function loadTalon() {
        window_or_global_1.default.talon.load({
            flow,
            onReady: () => {
                handleExecute();
            },
            onComplete: handleSuccess,
            onClosed: handleCancel,
            onError: handleError
        });
    }
    runTalon();
}
exports.default = startTalon;
//# sourceMappingURL=talon.js.map